 
const ConsignmentActions = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        // console.log("MAP Icon ", props)
        // props.context.componentParent.onCloseUploadDiv(e);
        // props.context.componentParent.onCloseRouteDiv(e);
        props.context.onShowLSPDeviationData(props);
    };

    return (
            <a onClick={handleRouteClick}  title="LSP Deviation"><i className="fa fa-random f20"></i>&nbsp;</a>
        
    );
};

export default ConsignmentActions;
